import React from 'react';
import { vFParamsPropShape } from './data-structure/v-f-proptypes';
import 'AppSrc/core/style/components/form/form-base-components/v-f-sub-section-title.css';


const VFSubSectionTitle = React.memo(({
  vFParams,
}) => {
  const {
    fieldTitle,
  } = vFParams;
  return (
    <h4 className="v-f-sub-section-title">{fieldTitle}</h4>
  );
});

VFSubSectionTitle.propTypes = {
  vFParams: vFParamsPropShape,
};

const VF_SUB_SECTION_TITLE = 'v-f-sub-section-title';

export {
  VF_SUB_SECTION_TITLE,
  VFSubSectionTitle,
};
